import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RegulaminEditFormModel } from './rule-edit-form.model';
import { Regulamin } from '../../../../../../shared/models/regulamin';
import { SharedValidators } from '../../../../../../shared/validators/shared-validators';

export class RuleEditFormBuilder {
  static createFormGroup(rule: Regulamin): FormGroup<RegulaminEditFormModel> {
    return new FormGroup<RegulaminEditFormModel>({
      id: new FormControl(
        { value: rule.id, disabled: true },
        Validators.required,
      ),
      dataOd: new FormControl(
        {
          value: rule.dataOd ? new Date(rule.dataOd) : null,
          disabled: this.dateFromDisabled(rule.dataOd),
        },
        Validators.required,
      ),
      dataDo: new FormControl(
        {
          value: rule.dataDo ? new Date(rule.dataDo) : null,
          disabled: true,
        },
        Validators.required,
      ),
      dataUtworzenia: new FormControl(
        {
          value: rule.dataUtworzenia ? new Date(rule.dataUtworzenia) : null,
          disabled: true,
        },
        Validators.required,
      ),
      tresc: new FormControl(rule.tresc ?? null, [
        Validators.required,
        SharedValidators.requiredTextWhichIsNotOnlyEmptyHtml(),
        Validators.maxLength(255),
      ]),
    });
  }
  static dateFromDisabled(dataOd: Date | null): boolean {
    const today = new Date();
    if (dataOd) {
      const inputDate = new Date(dataOd);
      return inputDate!.getTime() < today.getTime();
    } else return true;
  }
}
